import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface CreateAdminNoteParams {
  noteText: string;
}

interface CreateAdminNoteResponse {
  noteText: string;
}

export const useCreateAmazonAdminNote = ({
  encounterId,
  motherEncounterId,
  patientId,
}: {
  encounterId?: string;
  patientId?: string;
  motherEncounterId?: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<CreateAdminNoteResponse, CreateAdminNoteParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTER({
        patientId,
        motherEncounterId,
        encounterId,
      }),
      mutationFn: (params) => {
        return axiosInstance.post(
          `/amazon-clinic/encounters/${encounterId}/admin-note`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTER({
            patientId,
            motherEncounterId,
            encounterId,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTERS({
            patientId,
          }),
        });
      },
    },
  });
};
